import { connect } from 'react-redux'

import ChangeAliadaSearch from './ChangeAliadaSearch'
import {
  getServices,
  getUsers
} from '@src/redux/modules/entities'
import {
  fetch as fetchService,
  isFetching as isFetchingService
} from '@src/redux/modules/service'
import {
  search,
  isSearching,
  getAvailableAliadas as getSearchResults
} from '@src/redux/modules/search'

const mapStateToProps = (state, ownProps) => {
  const { serviceId, userId } = ownProps.params

  const services = getServices(state)
  const service = services[serviceId]

  const fetching = isFetchingService(state)
  const searching = isSearching(state)

  const searchResults = getSearchResults(state)

  return {
    bookingId: serviceId,
    booking: service,
    fetching,
    searching,
    searchResults
  }
}

const mapDispatchToProps = {
  fetch: fetchService,
  search
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeAliadaSearch)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/ChangeAliadaSearch/ChangeAliadaSearchContainer.js